export default "__VITE_ASSET__cf297578__"